import { gql } from '@apollo/client/core';

export const VENUE_FIELDS = gql`
  fragment VenueFields on Venue {
    id
    name
    currency
    locale
    timezone
    address {
      country
      city
      state
      street1
      street2
      postalCode
    }
  }
`;
